<template>
  <list
    ref="list"
    :get-data-func="api.list"
    :page="true"
    :query-params="params"
    :show-checkbox="$permission.canDel()"
    :show-query="showQuery"
    row-key="VoiceId"
    unit="语言资料管理"
  >
    <template slot="toolbar-right">
      <slot name="toolbar-right"></slot>
    </template>
    <template slot="query">
      <el-form-item label="资料类别">
        <el-select v-model="params.Category" clearable>
          <el-option value="科三灯光" label="科三灯光" />
          <el-option value="科三路考" label="科三路考" />
        </el-select>
      </el-form-item>
      <el-form-item label="资料标题">
        <el-input v-model="params.Title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="params.Status" clearable>
          <el-option :value="0" label="草稿"></el-option>
          <el-option :value="1" label="待审批"></el-option>
          <el-option :value="2" label="退回"></el-option>
          <el-option :value="3" label="已审批"></el-option>
        </el-select>
      </el-form-item>
    </template>
    <template slot="table">
      <el-table-column align="center" label="资料类别" min-width="200" prop="Category"></el-table-column>
      <el-table-column align="center" label="资料标题" min-width="400" prop="Title" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="发布时间" min-width="150" prop="PublishTime">
        <template slot-scope="{row}">{{ $commonJs.toDateString(row.PublishTime) }}</template>
      </el-table-column>
      <el-table-column align="center" label="审批状态" min-width="160" prop="Status">
        <template slot-scope="{row}">
          <el-tag type="info" v-if="row.Status==0">草稿</el-tag>
          <el-tag type="warning" v-if="row.Status==1">待审批</el-tag>
          <el-tag type="danger" v-if="row.Status==2">退回</el-tag>
          <el-tag type="success" v-if="row.Status==3">已审批</el-tag>
        </template>
      </el-table-column>
      <slot name="column"></slot>
    </template>
  </list>
</template>
<script>
import list from '@/components/common/list';
import listMixin from '@/mixins/list';
export default {
  mixins: [listMixin],
  components: {
    list
  },
  data() {
    return {
      api: require('@/api/consult/lang').default,
      params: {
        Title: '',
        Category: '',
        Status: ''
      }
    }
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  }
}
</script>

<style>
</style>